import { render, staticRenderFns } from "./JwKechengList.vue?vue&type=template&id=5c4bde36&scoped=true"
import script from "./JwKechengList.vue?vue&type=script&lang=js"
export * from "./JwKechengList.vue?vue&type=script&lang=js"
import style0 from "./JwKechengList.vue?vue&type=style&index=0&id=5c4bde36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bde36",
  null
  
)

export default component.exports